(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.accordionPane = {
    attach: function (context) {


      var accordionButtons = $('.accordion__item .accordion__header button');
      var accordionPanels = $('.accordion__item .accordion__panel');

      accordionButtons.each(function (i) {
        var a = 'accordion-content-' + (i++);
        $(this).attr('aria-controls', a);
      });

      accordionPanels.each(function (i) {
        var b = 'accordion-content-' + (i++);
        $(this).attr('id', b);
      });

      function accordionToggle() {
        $('.accordion__item .accordion__header button').on('click', function (e) {
          var $control = $(this);

          var accordionContent = $control.attr('aria-controls');
          checkOthers($control[0]);

          var isAriaExp = $control.attr('aria-expanded');
          var newAriaExp = (isAriaExp == "false") ? "true" : "false";
          $control.attr('aria-expanded', newAriaExp);

          var isAriaHid = $('#' + accordionContent).attr('aria-hidden');
          if (isAriaHid == "true") {
            $('#' + accordionContent).attr('aria-hidden', "false");
            $('#' + accordionContent).css('display', 'block');
          }
          else {
            $('#' + accordionContent).attr('aria-hidden', "true");
            $('#' + accordionContent).css('display', 'none');
          }
        });
      };

      function checkOthers(elem) {
        for (var i = 0; i < accordionButtons.length; i++) {
          if (accordionButtons[i] != elem) {
            if (($(accordionButtons[i]).attr('aria-expanded')) == 'true') {
              $(accordionButtons[i]).attr('aria-expanded', 'false');
              var content = $(accordionButtons[i]).attr('aria-controls');
              $('#' + content).attr('aria-hidden', 'true');
              $('#' + content).css('display', 'none');
            }
          }
        }
      }

      accordionToggle();


    },
  };
})(jQuery, Drupal);
